/**
 * Environment access for the admin SPA.
 *
 * Admin API calls go DIRECTLY to api-node (no Next.js proxy). The NextAuth
 * session cookie is shared by host (localhost across ports in dev), so fetches
 * use credentials: 'include' and api-node's NextAuthGuard validates the JWE.
 */

/** Base URL of api-node (no trailing slash, no /api prefix). */
export const API_NODE_URL: string = (
  (import.meta.env.VITE_API_NODE_URL as string | undefined) ?? 'http://localhost:8100'
).replace(/\/+$/, '');

/** api-node mounts everything under the `api` global prefix. */
export const API_BASE_URL = `${API_NODE_URL}/api`;

/**
 * The admin SPA and the auction are different applications with different
 * sessions (2026-09-26). Every request to api-node says it comes from the
 * admin, and api-node then authenticates it by the admin's own cookie and
 * nothing else (apps/api/src/common/auth/admin-session.ts). A selector, not a
 * credential. EventSource cannot send headers, so the stream uses the query form.
 */
export const APP_HEADERS: Record<string, string> = { 'x-cf-app': 'admin' };
export const APP_QUERY = { cfApp: 'admin' } as const;

/**
 * Base URL of the auction site — owns the NextAuth session this SPA rides on,
 * and hosts the lot detail pages (`/cars/:id`) admin rows link out to.
 */
export const AUCTION_URL: string = (
  (import.meta.env.VITE_AUCTION_URL as string | undefined) ?? 'http://localhost:3100'
).replace(/\/+$/, '');

/**
 * Base URL of the local ledger (apps/local, local.cars-finders.com) — the
 * owners' own trading book, its own app and its own session. An admin's won
 * bid handed to it (local-ledger bridge) is opened there in a new tab
 * («Відкрити в обліку»). Defaults to production: the link only ever leaves
 * the SPA, so a missing variable degrades to the real ledger, not a dead host.
 */
export const LOCAL_APP_URL: string = (
  (import.meta.env.VITE_LOCAL_APP_URL as string | undefined) ?? 'https://local.cars-finders.com'
).replace(/\/+$/, '');
